export default __webpack_public_path__ + "static/media/portfolio.be892b10.png";